<template>
  <div>
    <div class="d-flex">
      <div class="d-flex mb-2">
        <AGCSelectGroup
          v-model="selectedParentTagId"
          :options="[{ id: null, name: tagLabelName }, ...tagOptions]"
          :value-field="'id'"
          :value-text-field="'name'"
          rules="required"
          :name="tagLabelName"
          :disabled="disabled"
        ></AGCSelectGroup>
        <BaseButton
          class="border-0 ml-1"
          variant="outline-primary"
          @click="deleteItem(index)"
          v-if="index"
          :disabled="disabled"
        >
          -刪除
        </BaseButton>
      </div>
    </div>
    <AGCCheckboxGroup
      v-if="selectedParentTagId"
      v-model="selectedSubTagIds"
      :options="subTagOption"
      :value-field="'id'"
      required
      :label="subTagLabelName"
      sub-label="(最多可選兩項)"
      rules="required"
      :name="subTagLabelName"
      :disabled="disabled"
      :max="2"
    ></AGCCheckboxGroup>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';
import vModelMixin from '@/mixins/v-model';
import AGCCheckboxGroup from '@/components/form/AGCCheckboxGroup.vue';
import AGCSelectGroup from '@/components/form/AGCSelectGroup.vue';

export default {
  name: 'MerchantTagAndSubtagsItem',
  mixins: [vModelMixin],
  components: {
    AGCCheckboxGroup,
    AGCSelectGroup,
    BaseButton,
  },
  props: {
    tagOptions: {
      type: Array,
      required: true,
    },
    subTagOptions: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    index: {
      type: Number,
    },
  },
  methods: {
    deleteItem(index) {
      this.inputVal.splice(index, 1);
      this.$emit('tag-delete');
    },
  },
  data: () => ({
    selectedParentTagId: null,
    selectedSubTagIds: [],
  }),
  computed: {
    subTagOption() {
      if (this.subTagOptions) {
        return this.subTagOptions[this.selectedParentTagId];
      }
      return [];
    },
    subTagLabelName() {
      if (this.tagOptions && this.selectedParentTagId) {
        const label = this.tagOptions.find(
          (option) => option.id === parseInt(this.selectedParentTagId, 10),
        );
        return `${label.name}分類`;
      }
      return '';
    },
    tagLabelName() {
      return `選擇主分類 ${this.index + 1}`;
    },
  },
  watch: {
    selectedParentTagId(val) {
      this.inputVal[this.index].id = val;
      this.inputVal[this.index].children = [];
      this.$emit('tag-select');
    },
    selectedSubTagIds(val) {
      this.inputVal[this.index].children = val;
    },
    inputVal(val) {
      this.selectedSubTagIds = val[this.index].children;
    },
  },
  mounted() {
    this.selectedParentTagId = this.inputVal[this.index].id;
    this.selectedSubTagIds = this.inputVal[this.index].children;
  },
};
</script>

<style></style>
